(ns app.front.view.attachment.list
  (:require [app.domain.attachment.model :as attachment-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.group.plan-review-integration-model :as plan-review-integration-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.acceptance.components :as acceptance]
            [app.front.acceptance.events :as acceptance-evt]
            [app.front.acceptance.subs :as acceptance-subs]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.requirement.components :as requirement]
            [app.front.requirement.events :as req-events]
            [app.front.review-v2.subs :as review-subs]
            [app.front.ui :as ui]
            [app.front.ui.add-widget :as ui-add]
            [app.front.ui.contextual-menu :as ctx-menu]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.ui.table :as ui-table]
            [app.front.ui.util :as uiu]
            [app.front.util :as futil :refer [for-all for-frag]]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.attachment.list-v2 :as list-v2]
            [app.front.view.attachment.list.util :as list-util]
            [app.front.view.attachment.modal :as modals]
            [app.front.view.attachment.subs :as subs]
            [app.front.view.attachment.upload :as att-upload]
            [app.front.view.pdf-markup.core :as pdf-markup]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.front.media-query :as media-query]
            [core.http]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-sub ::filter-types
  (fn [db]
    (::filter db #{})))

(rf/reg-event-db ::toggle-filter
  (fn [db [_ type]]
    (update db ::filter (fn [f]
                          (let [filter-types (or f #{})]
                            ((if (filter-types type) disj conj)
                             filter-types
                             type))))))

(defn attachment-types-present [edb language attachments]
  (->> attachments
       (mapcat :attachment/types)
       distinct
       (map (partial get edb))
       (map (juxt :db/id #(attachment-common/attachment-type-label % language)))
       (sort-by last)))

(rf/reg-sub ::all-types
  :<- [::entities/entity-db]
  :<- [:language]
  (fn [[edb language] [_ target-ids]]
    (let [target-ids (set target-ids)]
      (->> edb
           vals
           (filter #(-> % :entity/parent target-ids))
           (attachment-types-present edb language)))))

(rf/reg-sub ::any-attachments?
  (fn [[_ target-ids]]
    (rf/subscribe [::all-types target-ids]))
  (fn [types _]
    (-> types seq boolean)))

(rf/reg-event-fx ::set-attachment-attr
  (fn [_ [_ app-id attachment-id attr value]]
    {:dispatch [::process/signal
                app-id
                [:process.signal/attachment-set-meta
                 {:attachment-id attachment-id
                  attr           value}]]}))

(rf/reg-event-fx ::set-attachment-visibility
  (fn [_ [_ app-id attachment-id restrict?]]
    {:dispatch [::process/signal
                app-id
                [:process.signal/attachment-set-visibility-restrictions
                 {:attachment-id attachment-id
                  :restrict?     restrict?}]
                {:notify {:success (if restrict?
                                     :attachments/visibility-restricted
                                     :attachments/visibility-unrestricted)}}]}))

(rf/reg-sub ::attachment-types-with-i18n
  (fn [[_ id]]
    {:pre [(integer? id)]}
    [(rf/subscribe [:app.front.view.application/attachment-types])
     (rf/subscribe [::entities/entity-db])
     (rf/subscribe [::subs/attachment-types id])
     (rf/subscribe [:language])])
  (fn [[attachment-types edb current-types lang] [_ _]]
    (->> attachment-types
         du/entity-id-set
         (set/union (->> current-types du/entity-id-set))
         (map (juxt #(attachment-common/attachment-type-label (get edb %) lang) #(get edb %)))
         (sort-by first)
         (map (fn [[text type]] {:id (:db/id type) :label text})))))

(def latest-file list-util/latest-file)
(def search-attachments list-util/search-attachments)

(defn sort-rows [[attr descending?] rows]
  (if attr
    (let [sort-key-fn (case attr
                        :attachment.version.file/filename #(-> (latest-file %)
                                                               :attachment.version.file/filename)
                        :attachment/types #(first (get % attr))
                        :latest-change #(get-in % [:latest-change :ts])
                        #(get % attr))]
      (sort-by sort-key-fn (if descending? > <) rows))
    rows))

(defn search-download [tr *search-string selected id property? bond?]
  (let [selected-href (cond
                        property?
                        (str "/api/command/attachment/download-selected-property?property-id=" id
                             "&attachment-ids="
                             (str/join "&attachment-ids=" selected))
                        bond?
                        (str "/api/command/attachment/download-selected-bond?bond-id=" id
                             "&attachment-ids="
                             (str/join "&attachment-ids=" selected))

                        :else
                        (str "/api/command/attachment/download-selected?workspace-id=" id
                             "&attachment-ids="
                             (str/join "&attachment-ids=" selected)))
        all-href      (cond
                        property?
                        (str "/api/command/attachment/download-all-property?property-id=" id)
                        bond?
                        (str "/api/command/attachment/download-all-bond?bond-id=" id)
                        :else
                        (str "/api/command/attachment/download-all?workspace-id=" id))]
    [:div.flex.flex-wrap.w-full.gap-2.mb-2
     [:div.attachment-search.flex-1.w-full.sm:w-auto {:style {:min-width "200px"}}
      [ui/search {:size                    :small
                  :id                      "attachment-search-input"
                  :placeholder             (tr [:search/search])
                  :label-text              (tr [:attachments/search])
                  :close-button-label-text (tr [:search/empty])
                  :value                   @*search-string
                  :on-change               #(reset! *search-string (futil/tval %))
                  :clear-fn                #(reset! *search-string "")}]]
     [:div.attachment-download
      (cc/button
        {:kind             :tertiary
         :size             :small
         :icon             i/download
         :icon-description ""
         :href             (if (seq selected) selected-href all-href)}
        (tr [(if (seq selected)
               :attachments/download-selected
               :attachments/download-all)]))]]))

(defn filters [{:keys [target-ids]}]
  (if-let [present-types (<sub [::all-types target-ids])]
    (let [filter-types (<sub [::filter-types])
          tr           (<sub [:tr])]
      [:div.flex.flex-wrap.lg:flex-nowrap.my-8
       [:div.mb-2.lg:mb-0.w-64.text-base
        (tr [:attachments/filter])]
       (if (<sub [::ws-subs/loading-config?])
         (->> (cc/button-skeleton)
              (repeat (count present-types))
              (into [:div.flex.gap-2]))
         (into
           [:div.flex.flex-wrap]
           (for [[a-type translation] present-types]
             [:button.bx--btn.bx--btn--secondary.bx--btn--sm.filter-btn.mb-2.mr-2
              {:class    (when (contains? filter-types a-type)
                           "filter-btn-active")
               :on-click #(>evt [::toggle-filter a-type])}
              translation])))])
    [:div]))

;; Expanded attachment details

(defn conversion-details [{:keys [id tr]}]
  (r/with-let [*log-visible? (r/atom false)]
    (let [file                                         (<sub [::subs/latest-file id])
          {:attachment.version.file/keys [archivable
                                          valid-pdf?]} file
          valid?                                       (or archivable valid-pdf?)
          ;; false needs to be explicitly checked, as nil means "not checked yet"
          pdf-validation-not-failed?                   (not= false valid-pdf?)]
      (when (or (some? archivable) (some? valid-pdf?))
        [:div.py-4
         [:div.attachment-table__archivable
          [:div
           (cc/icon {:icon        (if valid? i/check i/circle-attention)
                     :fill        (if valid? "green" "#EFC100")
                     :description ""})]
          [:span.mr-2 (tr [(cond
                             archivable :attachment/archivable
                             (true? valid-pdf?) :attachment/valid-pdf
                             (false? valid-pdf?) :attachment/invalid-pdf
                             :else :attachment/not-archivable)])]
          (when (and (not valid?)
                     pdf-validation-not-failed?)
            (cc/link {:on-click #(swap! *log-visible? not)
                      :href     "#"}
                     (if @*log-visible?
                       (tr [:attachment/hide-conversion-log])
                       (tr [:attachment/show-conversion-log]))))]
         (when (and @*log-visible? pdf-validation-not-failed?)
           [:div
            [ui/help (tr [:attachment/pdf-a-help])]
            [:div.font-mono.bg-ui-light-gray.p-4.rounded-md.text-sm.max-h-64.overflow-auto
             (->> file :attachment.version.file/conversion-data :conversion-log
                  (map (fn [log-row] [:span.block.whitespace-nowrap log-row]))
                  (into [:<>]))]])]))))

(defn conversion-details-v2 [{:keys [tr selected-version-id]}]
  (r/with-let [*log-visible? (r/atom false)]
    (let [file                                           (<sub [::subs/latest-file-for-version
                                                                selected-version-id])
          {:attachment.version.file/keys [archivable
                                          valid-pdf?
                                          pdf-features]} file
          pdfa?                                          (or archivable (contains? pdf-features :pdf-feature/pdfa))
          valid?                                         (or pdfa? valid-pdf?)
          signed-pdf?                                    (contains? pdf-features :pdf-feature/signed)
          ;; false needs to be explicitly checked, as nil means "not checked yet"
          pdf-validation-not-failed?                     (not= false valid-pdf?)
          ;; show section for any explicit signal, including legacy archivable false
          ;; signed-pdfs are always covered with valid-pdf?
          show-conversion-details?                       (or (some? archivable)
                                                             (some? valid-pdf?)
                                                             (contains? pdf-features :pdf-feature/pdfa))]
      (when show-conversion-details?
        [:div.py-4
         [:div.attachment-table__archivable
          [:div
           (cc/icon {:icon        (cond
                                    signed-pdf? i/recommend
                                    valid?      i/check
                                    :else       i/circle-attention)
                     :fill        (cond valid? "green" :else "#EFC100")
                     :description ""})]
          [:span.mr-2 (tr [(cond
                             pdfa?               :attachment/archivable
                             signed-pdf?         :attachment/certified-pdf
                             (true? valid-pdf?)  :attachment/valid-pdf
                             (false? valid-pdf?) :attachment/invalid-pdf
                             :else               :attachment/not-archivable)])]
          (when (and (not valid?)
                     pdf-validation-not-failed?)
            (cc/link {:on-click #(swap! *log-visible? not)
                      :href     "#"}
                     (if @*log-visible?
                       (tr [:attachment/hide-conversion-log])
                       (tr [:attachment/show-conversion-log]))))]
         (when (and @*log-visible? pdf-validation-not-failed?)
           [:div
            [ui/help (tr [:attachment/pdf-a-help])]
            [:div.font-mono.bg-ui-light-gray.p-4.rounded-md.text-sm.max-h-64.overflow-auto
             (->> file :attachment.version.file/conversion-data :conversion-log
                  (map (fn [log-row] [:span.block.whitespace-nowrap log-row]))
                  (into [:<>]))]])]))))

(defn select-types
  [{:keys [id process-target-id tr]}]
  (r/with-let [*multi-select-v (r/atom 1)]
    (let [available-types (<sub [::attachment-types-with-i18n id])
          types           (<sub [::subs/attachment-types id])
          language        (<sub [:language])]
      [:div.bx--col-xs-12.bx--col-lg-6.multi-select
       (if (<sub [::ws-subs/loading-config?])
         (cc/select-skeleton {})
         (cc/multi-select
           {:id                     (str id "-types")
            ;; The key hack forces the component to be redrawn (and thus closes the dropdown)
            ;; if the user attempts to remove the final remaining choice.
            ;; Otherwise, we DO NOT force redraw the component even if the selection changes
            ;; (and thus we keep the dropdown open).
            :key                    (str/join "-" [id "type" @*multi-select-v])
            :class-name             "attachment-type-multi-select-wo-clear-all-btn"
            :label                  (attachment-common/types-str tr types)
            :title-text             (tr [:attachment/types])
            :initial-selected-items (->> types
                                         (map (fn [type]
                                                {:id    (:db/id type)
                                                 :label (attachment-common/attachment-type-label type language)})))
            :items                  available-types
            :on-change              (fn [e]
                                      (let [values (attachment-common/keywords-from-multi-select e)]
                                        (if (seq values)
                                          (>evt [::set-attachment-attr
                                                 process-target-id
                                                 id
                                                 :attachment/types
                                                 values])
                                          (swap! *multi-select-v inc))))}))])))

(defn edit-drawing-number
  [{:keys [id process-target-id tr]}]
  [:div.bx--col-xs-4.bx--col-lg-2
   [ui/text-input {:id            (str id "-drawing")
                   :label-text    (tr [:attachment/drawing-number-optional])
                   :default-value (<sub [::subs/drawing-number id])
                   :on-change     #(>evt [:core.front.event/input-change
                                          [::set-attachment-attr
                                           process-target-id
                                           id
                                           :attachment/drawing-number
                                           (futil/tval %)]])}]])

(defn edit-description
  [{:keys [id process-target-id tr]}]
  [:div.bx--col-xs-8.bx--col-lg-4
   [ui/text-input {:id            (str id "-contents")
                   :label-text    (tr [:attachment/description-optional])
                   :default-value (<sub [::subs/contents id])
                   :on-change     #(>evt [:core.front.event/input-change
                                          [::set-attachment-attr
                                           process-target-id
                                           id
                                           :attachment/contents
                                           (futil/tval %)]])}]])

(defn version-list
  [{:keys [id tr *selected-version-id selected-version-id]}]
  (let [versions (<sub [::subs/versions-for-attachment id])]
    [:div.attachment-table__versions__list
     [:ol
      (for-frag [version versions]
        [:li
         {:on-click #(reset! *selected-version-id (:db/id version))
          :class    (when (= (:db/id version) selected-version-id)
                      "selected")}
         [:span {:class (cond
                          (= (:db/id version) selected-version-id)
                          "file-version_selected"
                          (:attachment.version/authority-markup? version)
                          "file-version-markup__link"
                          :else
                          "file-version__link")}
          (if (:attachment.version/authority-markup? version)
            (tr [:attachments/markup-version] [(:attachment.version/version version)])
            (tr [:attachments/version-number] [(:attachment.version/version version)]))]])]]))

(defn- attachment-version-acceptance [tr selected-version-id]
  (for-frag [acceptance (<sub [::acceptance-subs/entity-pending-acceptances selected-version-id])]
    [acceptance/render-acceptance tr :entity.type/attachment-version acceptance]))

(defn version-details
  [{:keys [id tr selected-version-id version-specific-conversion-info?]} & [additional-content]]
  (let [version (<sub [::subs/version selected-version-id])]
    [:div.bg-ui-09.p-4.flex.flex-col.gap-2.h-full
     [:div
      (into
        [:div.attachment-table__versions__files]
        (let [files (->> version
                         :attachment.version/files
                         (sort-by :entity/created))]
          [[:div (cc/link {:href (attachment-common/attachment-version-link id (:db/id (last files)) true)}
                          (:attachment.version.file/filename (last files)))]
           (when (du/at-least-two? files)
             [:div "[" (cc/link {:href (attachment-common/attachment-version-link id (:db/id (first files)) true)}
                                (tr [:attachment/original-version])) "]"])]))
      [:div.attachment-table__versions__creator
       (tr [:attachment/added-by]
           [((<sub [::date-util/date-time-fn]) (:entity/created version))
            (user-model/full-name (:entity/creator version))])]
      (when version-specific-conversion-info?
        [conversion-details-v2 (util/mmap tr selected-version-id)])]
     additional-content]))

(defn visibility-details
  [{:keys [id process-target-id tr]}]
  (let [can-alter? (<sub [::subs/can-alter-visibility? process-target-id id])
        on-click   (when can-alter?
                     (fn [restrict?] (>evt [::set-attachment-visibility process-target-id id restrict?])))]
    [attachment-common/visibility-details
     (p/assoc-if {:tr          tr
                  :owner-name  (<sub [::subs/creator-name id])
                  :restricted? (<sub [::subs/visibility-restricted? id])}
                 :on-click on-click)]))

(defn handle-bluebeam-package
  [{:keys [process-target-id entity markup-type]}]
  (>evt [::req-events/review-bluebeam-authentication
         (util/mmap {:application-id process-target-id
                     :provider       :bluebeam
                     :type           markup-type}
                    entity)]))

(defn pdfa-attachment? [attachment]
  (boolean
    (attachment-model/is-archivable? attachment)))

(defn expanded-actions
  [{:keys [id process-target-id tr property? bond?]}]
  (let [acceptance-value                   (<sub [::subs/latest-acceptance-value id])
        ext-tool-name                      (<sub [::review-subs/plan-review-tool-name])
        ext-review-signal                  [:process.signal/attachment-lock-and-push-for-external-editing {:attachment-id id}]
        end-ext-review-signal              [:process.signal/attachment-unlock-and-pull-from-external-editing {:attachment-id id}]
        integration-config-service         (<sub [::review-subs/integration-config-service])
        attachment                         (<sub [::subs/attachment id])
        loading?                           (or (<sub [::review-subs/integration-authentication-processing?])
                                               (<sub [::process/signal-processing? :process.signal/attachment-lock-and-push-for-external-editing])
                                               (<sub [::process/signal-processing? :process.signal/attachment-unlock-and-pull-from-external-editing]))
        session-id                         (:attachment/session-id attachment)
        unlock-only-from-external-editing? (<sub [::process/signal-permitted?
                                                  process-target-id
                                                  [:process.signal/attachment-unlock-only-from-external-editing {:attachment-id id}]])]
    [:div.flex.flex-wrap.justify-end.items-end.gap-2
     (when (and (<sub [::process/signal-permitted? process-target-id ext-review-signal])
                ext-tool-name)
       (if loading?
         [:div.w-fit (cc/inline-loading {:description (tr [:file/processing])})]
         (cc/button
           {:id       (str "mark-up-attachment-btn-" id)
            :kind     :tertiary
            :icon     i/external-link
            :on-click (fn [_]
                        (case integration-config-service
                          :integration-config.service/bluebeam (handle-bluebeam-package
                                                                 {:process-target-id process-target-id
                                                                  :entity            attachment
                                                                  :markup-type       :markup})

                          (do
                            (>evt [::process/signal process-target-id ext-review-signal])
                            ;; cannot be called in an on-success handler because pop-up blocker may kill it
                            ;; unfortunately this means that external review tool may open before our back-end is ready
                            (-> (plan-review-integration-model/single-attachment-review-url attachment)
                                futil/open-in-new-tab-or-window))))}
           [:div.flex.gap-2
            (tr [:process.signal/review-open-external-tool]
                [ext-tool-name])])))
     (when (and session-id
                unlock-only-from-external-editing?
                ext-tool-name)
       (cc/button
         {:id       (str id "-open-session-from-attachment-button")
          :on-click (fn []
                      (>evt [::req-events/review-integration-service.success
                             {:entity-id id
                              :provider  :bluebeam}
                             ;; Note: This "success" event is reused here even though there is no HTTP call.
                             ;; We already have a valid Bluebeam session-id for this attachment and only need
                             ;; to route it through the same success handler pipeline that normally runs after
                             ;; a real integration-service success. The pipeline:
                             ;;   - expects nil as the error payload (no HTTP request was made), and
                             ;;   - expects a tx-changes style map from which it can extract the session-id
                             ;;     and update the session-confirmation state / open the session modal.
                             ;; The entity db is not updated here; the map shape is only to satisfy the handler.
                             nil
                             {id {:attachment/session-id [:attachment/session-id session-id]}}]))}
         [:div.flex.gap-2
          (tr [:review/open-session-from-attachment-review]
              [ext-tool-name])]))
     (when (and (<sub [::process/signal-permitted? process-target-id end-ext-review-signal])
                ext-tool-name
                ;; session-id is generated from a Bluebeam markup process, so if it's not nil,
                ;; it means the attachment is in Bluebeam attachment review process and could be finalized
                ;; For other tools, we can still allow user to end review process as long as the signal is permitted.
                (or (not unlock-only-from-external-editing?)
                    session-id))
       (if loading?
         [:div.w-fit (cc/inline-loading {:description (tr [:file/processing])})]
         (cc/button
           {:id       (str "mark-up-attachment-btn-" id)
            :kind     :tertiary
            :on-click (fn [_]
                        (case integration-config-service
                          :integration-config.service/bluebeam (handle-bluebeam-package
                                                                 {:process-target-id process-target-id
                                                                  :entity            attachment
                                                                  :markup-type       :end-markup})
                          (>evt [::process/signal process-target-id end-ext-review-signal])))}
           [:div.flex.gap-2
            (tr [:process.signal/review-return-from-external-tool]
                [ext-tool-name])])))
     (when (and (not (or property? bond?))
                (not= :acceptance.value/ok acceptance-value))
       [att-upload/upload-version-button {:attachment-id id
                                          :parent-id     process-target-id}])
     (when (or (<sub [::subs/can-delete-attachment? process-target-id id])
               property?
               bond?)
       (cc/button
         {:id       (str "delete-attachment-btn-" id)
          :kind     :tertiary
          :icon     i/trash
          :on-click #(>evt [::modals/delete-clicked id])}
         (tr [:attachments/delete])))]))

(defn metadata-edit-controls [{:keys [id tr process-target-id]}]
  (let [disabled?      (not (<sub [::process/signal-permitted?
                                   process-target-id
                                   [:process.signal/attachment-set-meta {:attachment-id id}]]))
        drawing-number (<sub [::subs/drawing-number id])]
    [:<>
     (if disabled?
       (when (-> drawing-number str/blank? not)
         [:<> [:h6.inline-block.mr-1 (tr [:attachment/drawing-number]) ":"] drawing-number])
       [:div.attachment-table__metadata-inputs.bx--row
        [select-types (util/mmap id process-target-id tr)]
        [edit-drawing-number (util/mmap id process-target-id tr)]
        [edit-description (util/mmap id process-target-id tr)]])]))

(defn open-preview-button [{:keys [id tr selected-version-id]}]
  (when (<sub [::subs/can-preview? selected-version-id])
    [:div.attachment-table__preview
     [:div.attachment-table__open_preview.flex.flex-col.gap-2
      (cc/button {:kind       :tertiary
                  :class-name "whitespace-nowrap"
                  :on-click   #(>evt [::modals/preview-clicked id selected-version-id])}
                 (tr [:attachment/open-preview]))
      [pdf-markup/open-pdf-markup-button
       (util/mmap id tr selected-version-id)]]]))

(defn edit-lock-details [{:keys [id tr]}]
  (when-let [locked-by (<sub [::subs/locked-for-editing-by id])]
    [:div.mb-3
     (let [text (tr [:attachments/locked-by]
                    [(user-model/full-name locked-by)])]
       [:div.flex.items-center
        (cc/icon {:icon        i/lock
                  :class-name  "mr-2"
                  :description text})
        text])]))

(defn expanded-row-details [{:keys [id tr process-target-id property? bond?]}]
  (r/with-let [*selected-version-id (r/atom nil)]
    (let [latest-version-id                 (<sub [::subs/latest-version-id id])
          selected-version-id               (or @*selected-version-id latest-version-id)
          version-specific-conversion-info? (<sub [::ff/enabled? :feature-flag.id/version-specific-conversion-info])]
      [:<>
       [:div.divide-y-2.divide-gray-300.divide-solid
        [:div.attachment-table__version-preview.py-4
         [:div.mt-2.flex.flex-1
          (when-not (or property? bond?)
            [version-list (util/mmap id tr *selected-version-id selected-version-id)])
          [:div.flex.lg:flex-nowrap.flex-wrap.flex-1.gap-4.justify-between
           [:div
            [version-details (util/mmap id tr selected-version-id version-specific-conversion-info?)
             [attachment-version-acceptance tr selected-version-id]]]
           [open-preview-button (util/mmap id tr selected-version-id)]]]]
        (when-not (or bond? property?)
          [visibility-details (util/mmap id process-target-id tr)])
        (when-not version-specific-conversion-info?
          [conversion-details (util/mmap id tr)])]
       [edit-lock-details (util/mmap id tr)]])))

(defn expanded-attachment-row [{:keys [id tr process-target-id property? bond?]}]
  [:<>
   [metadata-edit-controls (util/mmap id tr process-target-id)]
   [expanded-row-details (util/mmap id tr process-target-id property? bond?)]
   [expanded-actions (util/mmap id process-target-id tr property? bond?)]])

;; Attachment rows and contextual actions

(rf/reg-sub ::show-acceptance-changes-button?
  (fn [[_ target-entity-id attachment-id acceptance-parent-id]]
    {:pre [(integer? target-entity-id)
           (integer? attachment-id)]}
    [(rf/subscribe [::subs/can-create-acceptance? target-entity-id :acceptance.value/needs-changes acceptance-parent-id])
     (rf/subscribe [::subs/latest-acceptance-value attachment-id])
     (rf/subscribe [::acceptance-evt/review-id-for-new-acceptance acceptance-parent-id])])
  (fn [[can-create? acceptance-value review-id]]
    (and can-create?
         (not= :acceptance.value/needs-changes acceptance-value)
         (nil? review-id))))

(defn acceptance-modal-button
  [{:keys [id process-target-id acceptance-parent-id tr]}]
  (when (<sub [::show-acceptance-changes-button? process-target-id id acceptance-parent-id])
    (let [title (str (tr [:entity.type/attachment]) " " (tr [:acceptance.value/needs-changes]))]
      {:title            title
       :icon             i/circle-info
       :icon-description title
       :data-cy          (str "request-changes-button-" (<sub [::subs/latest-filename id]))
       :on-click         #(>evt [::modals/acceptance-clicked id])})))

(defn create-acceptance
  [{:keys [id process-target-id acceptance-parent-id tr]}]
  (when (<sub [::subs/can-create-acceptance? process-target-id :acceptance.value/ok acceptance-parent-id])
    (let [review-id        (<sub [::acceptance-evt/review-id-for-new-acceptance acceptance-parent-id])
          acceptance-value (<sub [::subs/latest-acceptance-value id])
          title            (tr [:approve-target]
                               [(str/lower-case (tr [:entity.type/attachment]))])]
      (when (not= :acceptance.value/ok acceptance-value)
        {:title            title
         :icon             i/check
         :icon-description title
         :data-cy          (str "accept-button-" (<sub [::subs/latest-filename id]))
         :on-click         #(>evt [::acceptance-evt/create
                                   process-target-id
                                   acceptance-parent-id
                                   :acceptance.value/ok
                                   nil
                                   review-id])}))))

(defn attachment-visibility-button
  [{:keys [id process-target-id tr]}]
  (when (<sub [::subs/can-alter-visibility? process-target-id id])
    (if (<sub [::subs/visibility-restricted? id])
      (let [title (tr [:attachment/unrestrict])]
        {:title            title
         :icon             i/eye
         :icon-description title
         :on-click         #(>evt [::set-attachment-visibility process-target-id id false])})
      (let [title (tr [:attachment/restrict])]
        {:title            title
         :icon             i/eye-off
         :icon-description title
         :on-click         #(>evt [::set-attachment-visibility process-target-id id true])}))))

(defn delete-modal-button
  [{:keys [id process-target-id tr property? bond?]}]
  (when (or (<sub [::subs/can-delete-attachment? process-target-id id])
            property?
            bond?)
    (let [title (tr [:attachments/delete])]
      {:title            title
       :icon             i/trash
       :icon-description title
       :data-cy          (str "delete-attachment-modal-button-" (<sub [::subs/latest-filename id]))
       :on-click         #(>evt [::modals/delete-clicked id])})))

(defn unlock-modal-button
  [{:keys [id process-target-id tr property? bond?]}]
  ;; Show unlock action only when this specific signal is available for the attachment.
  (when (and (not (or property? bond?))
             (<sub [::process/signal-permitted?
                    process-target-id
                    [:process.signal/attachment-unlock-only-from-external-editing {:attachment-id id}]]))
    (let [title (tr [:attachments/unlock])]
      {:title            title
       :icon             i/lock-open
       :icon-description title
       :data-cy          (str "unlock-attachment-modal-button-" (<sub [::subs/latest-filename id]))
       :on-click         #(>evt [::modals/unlock-clicked id])})))

(defn action-column
  [{:keys [id process-target-id acceptance-parent-id tr property? bond?]}]
  (let [content [{:actions [(create-acceptance (util/mmap id process-target-id acceptance-parent-id tr))
                            (acceptance-modal-button (util/mmap id process-target-id acceptance-parent-id tr))]}
                 {:title   (tr [:attachment/visibility-section])
                  :actions [(attachment-visibility-button (util/mmap id process-target-id tr))]}
                 {:actions [(unlock-modal-button (util/mmap id process-target-id tr property? bond?))]}
                 {:actions [(delete-modal-button (util/mmap id process-target-id tr property? bond?))]}]]
    (when (ctx-menu/has-actions? content)
      [:div.mr-2
       [ctx-menu/menu
        content
        {:data-cy      (str "attachment-menu-" (<sub [::subs/latest-filename id]))
         :toggle-props {:aria-label (tr [:attachment/actions])}}]])))

(defn acceptance-changes-widget
  [{:keys [id process-target-id tr on-close]}]
  (r/with-let [*acceptance-text (r/atom "")]
    (let [latest-non-markup-version-id (<sub [::subs/latest-non-markup-version-id id])
          latest-version-id            (<sub [::subs/latest-version-id id])
          review-id                    (<sub [::acceptance-evt/review-id-for-new-acceptance latest-version-id])]
      [:div.justify-end.flex>div.max-w-3xl.flex-1
       [ui-add/add-widget
        {:title   (tr [:acceptance.value/needs-changes])
         :icon    i/circle-info
         :data-cy "acceptance-add-widget"
         :buttons [{:text     (tr [:cancel])
                    :kind     :ghost
                    :on-click on-close}
                   {:text     (tr [:ok])
                    :on-click #(do
                                 (>evt [::modals/acceptance-changes-submitted
                                        process-target-id
                                        latest-version-id
                                        latest-non-markup-version-id
                                        @*acceptance-text
                                        review-id])
                                 (on-close))}]}
        [ui/text-area
         {:id          "attachment-acceptance-text"
          :data-cy     "attachment-acceptance-text"
          :label-text  (tr [:acceptance/request-text-field-title])
          :helper-text (tr [:acceptance/request-text-field-help])
          :value       @*acceptance-text
          :light       true
          :on-change   #(reset! *acceptance-text (-> % .-target .-value))
          :placeholder (tr [:acceptance/request-text-field-placeholder])}]]])))

(defn expanded-review-actions
  [{:keys [id process-target-id tr property? bond?]}]
  (r/with-let [*show-acceptance-changes? (r/atom false)]
    (let [acceptance-parent-id (<sub [::subs/latest-non-markup-version-id id])
          approve-action       (create-acceptance (util/mmap id process-target-id acceptance-parent-id tr))
          changes-action       (some-> (acceptance-modal-button
                                         (util/mmap id process-target-id acceptance-parent-id tr))
                                       (assoc :on-click #(reset! *show-acceptance-changes? true)))
          unlock-action        (unlock-modal-button (util/mmap id process-target-id tr property? bond?))
          actions              (remove nil? [approve-action changes-action unlock-action])]
      [:<>
       (if (not @*show-acceptance-changes?)
         (when (seq actions)
           (into [:div.flex.flex-wrap.justify-end.items-end.gap-2.mb-4]
                 (map (fn [{:keys [title] :as action}]
                        [cc/button (-> action
                                       (dissoc :title)
                                       (assoc :kind :tertiary))
                         title]))
                 actions))
         [acceptance-changes-widget
          {:id                id
           :process-target-id process-target-id
           :tr                tr
           :on-close          (fn [& _]
                                (reset! *show-acceptance-changes? false))}])])))

(defn expanded-attachment-row-v2 [{:keys [id tr process-target-id property? bond?]}]
  [:<>
   [metadata-edit-controls (util/mmap id tr process-target-id)]
   [expanded-row-details (util/mmap id tr process-target-id property? bond?)]
   [expanded-review-actions (util/mmap id process-target-id tr property? bond?)]
   [expanded-actions (util/mmap id process-target-id tr property? bond?)]])

(def tag-classes "lg:p-3 text-xs lg:text-sm font-semibold cursor-default max-w-full break-all md:break-word")

(defn tag-normal
  [props text]
  [ui/tag (merge {:type       :round
                  :color      :transparent
                  :class-name (str "border-solid lg:p-3 border lg:border-2 " tag-classes)}
                 props)
   text])

(defn tag-highlight
  [props text]
  [ui/tag (merge {:type       :round
                  :color      :blue
                  :class-name tag-classes}
                 props)
   text])

(defn status-column
  [{:keys [id tr]}]
  (let [acceptance-value (<sub [::subs/latest-acceptance-value id])
        authority?       (<sub [:session/authority-user?])
        locked-for-user  (<sub [::subs/locked-for-editing-by id])]
    (if locked-for-user
      [tag-normal
       {:data-cy "tag-attachment-locked"}
       (tr [:review/attachment-in-markup])]
      (case acceptance-value
        :acceptance.value/ok
        [tag-normal
         {:data-cy "tag-attachment-acceptance-ok"}
         (tr [:attachments/ok])]

        :acceptance.value/needs-changes
        [(if authority? tag-normal tag-highlight)
         {:data-cy "tag-attachment-acceptance-needs-changes"}
         (tr [:attachments/changes-needed])]

        ;; else
        [(if authority? tag-highlight tag-normal)
         {:data-cy "tag-attachment-new-version"}
         (tr [:attachments/new-version])]))))

(defn attachment-filename-column
  [{:keys [id tr property? bond?]}]
  (let [latest-version (<sub [::subs/latest-version id])
        filename       (<sub [::subs/latest-filename id])]
    [:<>
     [:div.attachment-table__file-name.truncate
      [:a.bx--link
       {:href (attachment-common/attachment-link id true)}
       filename]]
     (when-not (or property? bond?)
       [:div.attachment-table__version
        (tr [:attachments/version-number]
            [(-> latest-version :attachment.version/version)])])]))


(def modified-column list-util/modified-column)

(defn attachment-row-data
  [{:keys [id process-target-id tr editable? show-visibility? property? bond?]}]
  (let [filename             (<sub [::subs/latest-filename id])
        acceptance-parent-id (<sub [::subs/latest-non-markup-version-id id])]
    {:key              id
     :opts             {:data-cy (str "attachment-" filename)}
     :cols             [{:content [list-util/attachment-types-column (util/mmap id)]}
                        {:content [attachment-filename-column (util/mmap id tr property? bond?)]}
                        (when (and editable? (not (or bond? property?)))
                          {:opts    {:class-name "overflow-hidden tag-column"}
                           :content [status-column (util/mmap id tr)]})
                        (when show-visibility?
                          {:content [list-util/visibility-column (util/mmap id tr)]})
                        {:content [list-util/modified-column (util/mmap id)]}
                        (when editable?
                          {:opts    {:class-name "action-column"
                                     :data-cy    "attachment-actions"}
                           :content [action-column (util/mmap id
                                                              process-target-id
                                                              acceptance-parent-id
                                                              tr
                                                              property?
                                                              bond?)]})]
     :expanded-content [expanded-attachment-row
                        (util/mmap id process-target-id tr property? bond?)]}))

;; Attachment table

(defn modals
  [{:keys [tr process-target-id property? bond? render-preview-modal?]}]
  [:div
   {:data-cy "attachment-modals"}
   (when render-preview-modal?
     [modals/attachment-preview-modal (util/mmap tr)])
   [modals/acceptance-modal (util/mmap tr process-target-id)]
   [modals/delete-modal (util/mmap tr process-target-id property? bond?)]
   [modals/unlock-modal (util/mmap tr process-target-id)]])

(defn modals-v2
  [{:keys [tr process-target-id property? bond? render-preview-modal?]}]
  [:div
   {:data-cy "attachment-modals"}
   (when render-preview-modal?
     [modals/attachment-preview-modal (util/mmap tr)])
   [modals/delete-modal (util/mmap tr process-target-id property? bond?)]
   [modals/unlock-modal (util/mmap tr process-target-id)]])

(rf/reg-sub ::filtered-attachments
  (fn [[_ target-entity-id]]
    [(rf/subscribe [::subs/attachments-for-parent target-entity-id])
     (rf/subscribe [::filter-types])])
  (fn [[attachments filter-types]]
    (cond->> attachments
      (seq filter-types) (filter (comp (partial some filter-types)
                                       set
                                       (partial map :db/id)
                                       :attachment/types)))))

(rf/reg-sub ::has-filtered-attachments?
  (fn [[_ target-entity-id]]
    (rf/subscribe [::filtered-attachments target-entity-id]))
  (fn [attachments]
    (boolean (seq attachments))))

(rf/reg-sub ::search-result-ids
  (fn [[_ target-entity-id _ _]]
    (rf/subscribe [::filtered-attachments target-entity-id]))
  (fn [attachments [_ _target-entity-id search-string sorting]]
    (let [results (if (not (str/blank? search-string))
                    (search-attachments search-string attachments)
                    attachments)]
      (->> results
           (sort-rows sorting)
           (map :db/id)))))

(rf/reg-sub ::results-contain-restricted-attachments?
  (fn [[_ parent-id]]
    {:pre [(integer? parent-id)]}
    (rf/subscribe [::subs/restricted-attachment-ids-for-parent parent-id]))
  (fn [restricted [_ _ visible]]
    (-> (set/intersection restricted (set visible))
        seq
        boolean)))

(defn stateless-attachment-table-v1 [_]
  (let [*search-string (r/atom "")
        *sorting       (r/atom [])
        *scroll-to-ref (r/atom nil)]
    (r/create-class
      {:component-did-mount
       (fn [_]
         (when @*scroll-to-ref
           (.scrollIntoView @*scroll-to-ref)
           nil))
       :reagent-render
       (fn [{:keys [process-target-id workspace-id pre-selected-id editable? title on-select selected property? bond?
                    render-preview-modal?]
             :or   {editable?             true
                    render-preview-modal? true}}]
         (let [tr               (<sub [:tr])
               attachment-ids   (<sub [::search-result-ids process-target-id @*search-string @*sorting])
               show-visibility? (and (<sub [::results-contain-restricted-attachments? process-target-id attachment-ids])
                                     (<sub [::media-query/breakpoint-matches? :lg])
                                     (not (or bond? property?)))]
           [:<>
            [modals (util/mmap tr process-target-id property? bond? render-preview-modal?)]
            ^{:key "attachment-table"}
            [:div.attachments
             (when (<sub [::has-filtered-attachments? process-target-id])
               [:<>
                (when title
                  [:h3.mb-4.text-sm.font-semibold.leading-snug
                   (when pre-selected-id
                     {:ref (fn [element]
                             (when element
                               (reset! *scroll-to-ref element)))})
                   title])
                [search-download tr *search-string selected (or workspace-id process-target-id) property? bond?]])
             (when (seq attachment-ids)
               [:div.attachment-table-wrapper.lg:overflow-visible.overflow-auto
                #_{:clj-kondo/ignore [:deprecated-var]}
                [ui-table/table {:expandable?          editable?
                                 :class                "attachment-table"
                                 :tr                   tr
                                 :default-expanded-key pre-selected-id
                                 :on-select            on-select
                                 :selected             selected}
                 [[ui-table/table-header-sortable tr *sorting :attachment/types {:class "attachment-type-column"}]
                  [ui-table/table-header-sortable tr *sorting :attachment.version.file/filename]
                  (when (and editable? (not (or bond? property?))) [:th.tag-column (tr [:attachment/status])])
                  (when show-visibility?
                    [:th.visibility-column (tr [:attachment/visibility])])
                  [ui-table/table-header-sortable tr *sorting :latest-change]
                  (when editable?
                    [:td.action-column])]

                 (for-all [id attachment-ids]
                   (attachment-row-data (util/mmap id
                                                   process-target-id
                                                   tr
                                                   editable?
                                                   show-visibility?
                                                   property?
                                                   bond?)))]])]]))})))

(defn stateless-attachment-table-v2
  [{:keys [process-target-id workspace-id pre-selected-id editable? title on-select selected property? bond?
           render-preview-modal?]
    :or   {editable?             true
           render-preview-modal? true}}]
  (r/with-let [*search-string (r/atom "")
               *scroll-to-ref (r/atom nil)]
    (let [tr               (<sub [:tr])
          lang             (<sub [:language])
          attachments      (<sub [::filtered-attachments process-target-id])
          attachments      (if (not (str/blank? @*search-string))
                             (search-attachments @*search-string attachments)
                             attachments)
          attachment-ids   (mapv :db/id attachments)
          show-visibility? (and (<sub [::results-contain-restricted-attachments? process-target-id attachment-ids])
                                (<sub [::media-query/breakpoint-matches? :lg])
                                (not (or bond? property?)))
          cols             (list-v2/attachment-columns
                             (util/mmap bond?
                                        editable?
                                        lang
                                        property?
                                        show-visibility?
                                        tr))]
      [:<>
       [modals-v2 (util/mmap tr process-target-id property? bond? render-preview-modal?)]
       [:div.attachments
        (when (<sub [::has-filtered-attachments? process-target-id])
          [:<>
           (when title
             [:h3.mb-4.text-sm.font-semibold.leading-snug title])
           [search-download tr *search-string selected (or workspace-id process-target-id) property? bond?]])
        (when (seq attachments)
          [sortable-table/table
           {:cols          cols
            :configurable? true
            :expanded-func (when editable?
                             (fn [{:db/keys [id]}]
                               [expanded-attachment-row-v2
                                (util/mmap id process-target-id tr property? bond?)]))
            :get-focus?    (when pre-selected-id
                             (fn [{:db/keys [id]}]
                               (= id pre-selected-id)))
            :get-row-opts  (fn [{:db/keys [id] :as attachment}]
                             {:data-cy (str "attachment-"
                                            (-> attachment latest-file :attachment.version.file/filename))
                              :ref     (when (= id pre-selected-id)
                                         (fn [element]
                                           (when (and element (nil? @*scroll-to-ref))
                                             (reset! *scroll-to-ref element)
                                             (.scrollIntoView element))))})
            :id-func       :db/id
            :id            "attachment-list-v2"
            :items         attachments
            :get-status    (when (and editable? (not (or bond? property?)))
                             #(:status (list-v2/attachment-status tr %)))
            :on-clear      (when on-select #(on-select selected))
            :on-select     (when on-select (fn [_checked? id] (on-select [id])))
            :selection     selected
            :tr            tr}])]])))


(defn stateless-attachment-table [props]
  (if (<sub [::ff/enabled? :feature-flag.id/attachment-list-v2])
    [stateless-attachment-table-v2 props]
    [stateless-attachment-table-v1 props]))

(defn attachment-table [props]
  (r/with-let [*selected (r/atom #{})
               on-select (fn [ids]
                           (swap! *selected
                                  (fn [selected]
                                    (->> ids
                                         (reduce (fn [selected id]
                                                   (if (contains? selected id)
                                                     (disj selected id)
                                                     (conj selected id)))
                                                 selected)))))]
    [stateless-attachment-table (assoc props :selected @*selected :on-select on-select)]))

(def list-row
  (uiu/wrap-in :div.bx--row :div.bx--col-xs-12))

(defn- attachments-title [workspace tr lang]
  (when (some? workspace)
    (str (or (config-model/category-name workspace lang)
             (tr [(-> workspace :workspace/permit-type)]))
         " "
         (or (:workspace/municipal-case-id workspace)
             (:workspace/id workspace)))))

(defn related-workspace-attachments [{:keys [targets]}]
  (let [tr   (<sub [:tr])
        lang (<sub [:language])]
    (some->> targets
             (map (fn [{other-id :db/id other-ws :entity/parent}]
                    (when (<sub [::subs/has-attachments? other-id])
                      [attachment-table {:title             (attachments-title other-ws tr lang)
                                         :process-target-id other-id
                                         :workspace-id      (-> other-ws :workspace/id)
                                         :editable?         false}])))
             (remove nil?)
             seq
             (into [:<>
                    [:h3 (tr [:attachments/from-related])]]))))

(defn list-view [{:keys [target pre-selected-id can-edit-bond? render-preview-modal?]
                  :or   {render-preview-modal? true}}]
  (let [target-id        (:db/id target)
        property?        (eu/is-type? :entity.type/property target)
        bond?            (eu/is-type? :entity.type/bond target)
        related-targets  (when-not (or bond? property?)
                           (workspace-model/get-related-targets target))
        tr               (<sub [:tr])
        lang             (<sub [:language])
        all-target-ids   (->> (cons target related-targets)
                              (map :db/id))
        any-attachments? (<sub [::any-attachments? all-target-ids])]
    [:<>
     [list-row {:class "mt-4"}
      [requirement/attachment-requirements-list
       tr
       target-id]]
     [list-row
      [att-upload/upload-area tr target property? bond?]]
     (if any-attachments?
       [:<>
        [list-row
         [filters {:target-ids all-target-ids}]]
        [attachment-table (cond-> {:process-target-id     target-id
                                   :workspace-id          (-> target :entity/parent :workspace/id)
                                   :title                 (when-not bond?
                                                            (attachments-title (:entity/parent target) tr lang))
                                   :pre-selected-id       pre-selected-id
                                   :property?             property?
                                   :bond?                 bond?
                                   :render-preview-modal? render-preview-modal?}
                            bond? (assoc :editable? can-edit-bond?))]
        [list-row
         [related-workspace-attachments {:targets related-targets}]]]
       [:div.no-attachments
        {:class (when-not any-attachments? "mt-8")}
        (tr [:attachments/none])])]))
